import { type ApiClientResponse, apiClient, routes } from 'common/services';

export const getZipFile = async (id: string) => apiClient.post<Blob, ApiClientResponse<Blob>>(routes.events.zip(id));
